import React from "react";
import SplashPic from "../assets/studio NF3.jpg";
import "../FullWImgCard/fullWImageCard.css";

const FullWidthImageCard = (props) => {
  return <img className="full-w" alt={props.name} src={SplashPic} />;
};
export default FullWidthImageCard;
